<!-- Template -->
<template>
    <div class="col-3" :class="{hidden:hidden}" id="sidebar">
        <div class="name">
            <label>Site</label>
            <h1>{{hospital.locationName}}</h1>
        </div>

        <Navigation
            :active="active"
            :supportTicketsCount="ticketCount"
            :systemsCount="hospital.systemsCount"
            :id="hospital.id"
        />
        <Address v-if="hospital.address" :address="hospital.address" />
        <Contacts
            :hospital="hospital"
            :contacts="hospital.contacts"
            @new="contactDialog.show()"
            @select="contactDialog.show($event)"
        />
        <ContactDialog
            ref="contactDialog"
            @showRequestDeleteDialog="showRequestDeleteDialog"
            @showFeedbackDialog="showFeedbackDialog($event)"
            @fillContactDetails="fillContactDetails($event)"
        />
        <contact-feedback v-show="feedbackIsOn" @closeFeedbackDialog="closeFeedbackDialog" @backFromFeedbackDialog="backFromFeedbackDialog($event)" :backData="backData"></contact-feedback>
        <request-delete v-show="deleteIsOn" @closeRequestDeleteDialog="closeRequestDeleteDialog"></request-delete>
    </div>
</template>

<!-- Script -->

<script>
    import Address from "@/components/Sidebar/Address";
    import Contacts from "@/components/Sidebar/Contacts";
    import Navigation from "@/components/Sidebar/Navigation";
    import ContactDialog from "@/components/Dialogs/Contact";
    import ContactFeedback from "@/components/Dialogs/ContactFeedback";
    import RequestDelete from "@/components/Dialogs/RequestDelete";

    export default {
        name: "Sidebar",

        components: {
            Address,
            Contacts,
            Navigation,
            ContactDialog,
            ContactFeedback,
            RequestDelete
        },

        props: ["active", "hospital"],

        data() {
            return {
                deleteIsOn: false,
                feedbackIsOn: false,
                ticketCount: null,
                contact:null,
                backData:null,
                hidden: true     
            };
        },

        watch: {
            hospital: {
                deep: true,
                immediate: true,
                handler(value) {
                    if (value) {  
                        this.ticketCount = value.supportTicketsCount;     
                    }
                }
            }
        },
        
        computed: {
            contactDialog() {
                return this.$refs.contactDialog;
            }
        },

        methods: {
            showRequestDeleteDialog() {
                this.deleteIsOn = true;
            },

            showFeedbackDialog(data) {
                this.backData = data;
                this.feedbackIsOn = true;
            },

            closeRequestDeleteDialog() {
                this.deleteIsOn = false;
            },

            closeFeedbackDialog() {
                this.feedbackIsOn = false;
            },

            backFromFeedbackDialog(data){
                this.backData = data;
                this.feedbackIsOn = false;
                this.contactDialog.show(data);
            },
            fillContactDetails(contact){
                this.contact = contact;
            },

            show(){
                this.hidden = false;
            },
            hide(){
                this.hidden = true;
            }
        }
    };
</script>

